/* eslint-disable jsx-a11y/anchor-is-valid */
import { Modal, Button, Icon, Divider } from 'antd';
import React, { PureComponent } from 'react'
import EMOJI from '../../../assets/js/emoji'
import './dialogBox.less'
import API from '../../../api/api';
import moment from 'moment';

class DialogBox extends PureComponent {
    constructor(props) {
        super(props)
        this.modelClose = this.modelClose.bind(this);
        this.showExpression = this.showExpression.bind(this);
        this.onEditAreaFocus = this.onEditAreaFocus.bind(this);
        this.textAreaKeydown = this.textAreaKeydown.bind(this);
        this.active = this.active.bind(this);
        this.submit = this.submit.bind(this);
        this.selectEmoji = this.selectEmoji.bind(this)

        this.send = this.send.bind(this)
        this.state = {
            visible: false,
            modelData: '',
            msgType: '',
            tabindex: 1,
            popExpress: false,
            msgList: []
        }
    }

    componentWillReceiveProps(nextProps) {
        console.log(nextProps.msgType)
        this.setState({
            visible: nextProps.visible,
            modelData: nextProps.modelData
        })
        if (nextProps.modelData) {
            this.setState({
                msgType: nextProps.msgType,
                modelData: nextProps.modelData,
                visible: nextProps.visible
            })
            this.messageList({
                fromUserId: nextProps.modelData.fromUserId,
                toUserId: nextProps.modelData.toUserId,
                msgType: nextProps.msgType
            })
        }
    }

    async messageList(params) {
        let result = await API.messageList(params);
        if (!result) return;
        if (result.status === "1") {
            if (result.data && result.data.msgList) {
                this.setState({ msgList: result.data.msgList.reverse() })
            }
        }
    };

    componentDidMount() {

    }

    /**
     * model对话框关闭 
     */
    modelClose() {
        this.props.modelClose ?
            this.props.modelClose() :
            this.setState({ visible: false })
        this.setState({ popExpress: false, value: '' }) //清除表情框和以输入文字
    }

    showExpression() {
        this.setState({ popExpress: !this.state.popExpress })
    }

    /**
     * 
     * @param {*} param0 
     */
    onEditAreaFocus() {
        // this.setState({ popExpress: false })
    }

    /**
     * 取消输入框默认回车换行
     * @param {*} event 
     */
    textAreaKeydown(event) {
        const { popExpress } = this.state;
        popExpress && this.setState({ popExpress: false });
        if (event.keyCode !== 13) return
        event.preventDefault();
        this.send()
    }

    /**
     * 发送输入信息
     * @param {*} param0 
     */
    submit({ target: { value } }) {

    }

    async send() {
        const { popExpress } = this.state;
        popExpress && this.setState({ popExpress: false });
        let text = this.refs.editArea.innerHTML;
        var reg = /^\s+$/;
        if (!text) return;
        if (reg.test(text)) {
            this.refs.editArea.innerHTML = '';
            return;
        }
        let msg = EMOJI.Emoji2Word(text); //纯文本字符串 - 数据传送
        const { msgType, modelData } = this.state;
        let result = await API.sendMsg({
            msgType,
            fromUserId: modelData.toUserId,
            toUserId: modelData.fromUserId,
            msg
        });
        if (!result) return;
        if (result.status === "1") {
            let msgList = this.state.msgList.concat({
                createTime: moment().unix(),
                selfSendMsg: true,
                msg: text
            })
            this.setState({ msgList }, () => {
                this.messagesEnd.scrollIntoView({ behavior: "smooth" });
                this.refs.editArea.innerHTML = ''
            });
        } else {
            //发送失败
        }
    }

    active(tabindex) {
        this.setState({ tabindex })
    }

    /**
     * 点击表情
     * @param {*} title 
     * @param {*} emoji 
     * @param {*} type 
     */
    selectEmoji(title, type, cls) {
        let emoji = `<img src="http://s1.im-dangdang.com/online/20171204/ddTdnJ5Bfy.png" title="${title}" class="emoji ${cls}" type="${type}">`;
        let innerHTML = this.refs.editArea.innerHTML;
        this.refs.editArea.innerHTML = innerHTML + emoji
        this.refs.editArea.focus();
        var range = window.getSelection();//创建range
        range.selectAllChildren(this.refs.editArea);//range 选择obj下所有子内容
        range.collapseToEnd();//光标移至最后
    }

    getCurrentDate() {
        var now = new Date();
        var year = now.getFullYear(); //得到年份
        var month = now.getMonth(); //得到月份
        var date = now.getDate(); //得到日期
        // var day = now.getDay(); //得到周几
        var hour = now.getHours(); //得到小时
        var minu = now.getMinutes(); //得到分钟
        var sec = now.getSeconds(); //得到秒
        month = month + 1;
        if (month < 10) month = "0" + month;
        if (date < 10) date = "0" + date;
        if (hour < 10) hour = "0" + hour;
        if (minu < 10) minu = "0" + minu;
        if (sec < 10) sec = "0" + sec;
        return year + "-" + month + "-" + date + " " + hour + ":" + minu + ':' + sec;
    }

    render() {
        const {
            visible,
            modelData,
            //表情
            tabindex, //
            popExpress,
            msgList
        } = this.state

        let emojiDang = ["微笑", "撇嘴", "色", "发呆", "得意", "流泪", "害羞", "闭嘴", "睡", "大哭", "尴尬", "发怒", "调皮", "龇牙", "惊讶", "难过", "囧", "抓狂", "吐", "偷笑", "愉快", "白眼", "傲慢", "困", "惊恐", "流汗", "大笑", "悠闲", "奋斗", "咒骂", "疑问", "嘘", "晕", "衰", "骷髅", "敲打", "再见", "擦汗", "抠鼻", "鼓掌", "坏笑", "左哼哼", "右哼哼", "哈欠", "鄙视", "委屈", "快哭了", "阴险", "亲亲", "可怜", "高兴", "嘿哈", "耶", "笑哭", "捂脸", "机智", "皱眉", "奸笑", "吃瓜", "糗大了", "戳脸", "偷看", "无奈", "口罩", "惊吓", "思考", "吐血", "捂眼", "摸头", "打脸", "惊呆", "刀", "啤酒", "咖啡", "饭", "猪头", "玫瑰", "凋谢", "嘴唇", "爱心", "心碎", "蛋糕", "炸弹", "便便", "月亮", "太阳", "拥抱", "强", "弱", "握手", "胜利", "抱拳", "OK", "祈祷", "加油", "庆祝", "礼物", "红包", "蜡烛", "灯泡"],
            emojiHuangDou = ["微笑", "撇嘴", "色", "发呆", "得意", "流泪", "害羞", "闭嘴", "睡", "大哭", "尴尬", "发怒", "调皮", "龇牙", "惊讶", "难过", "囧", "抓狂", "吐", "偷笑", "愉快", "白眼", "傲慢", "困", "惊恐", "流汗", "大笑", "悠闲", "奋斗", "咒骂", "疑问", "嘘", "晕", "衰", "骷髅", "敲打", "再见", "擦汗", "抠鼻", "鼓掌", "坏笑", "左哼哼", "右哼哼", "哈欠", "鄙视", "委屈", "快哭了", "阴险", "亲亲", "可怜", "高兴", "嘿哈", "耶", "笑哭", "捂脸", "机智", "皱眉", "奸笑", "吃瓜", "糗大了", "戳脸", "偷看", "无奈", "口罩", "惊吓", "思考", "吐血", "捂眼", "摸头", "打脸", "惊呆"];
        return (
            <Modal
                visible={visible}
                footer={null}
                destroyOnClose //默认关闭后状态不会自动清空, 如果希望每次打开都是新内容
                closable={true}
                centered
                // afterClose={} //Modal 完全关闭后的回调
                onCancel={this.modelClose} //点击遮罩层或右上角叉或取消按钮的回调
                className="dialog-box-model"
                width={600}
            >
                <div className="name">{modelData && modelData.fromNickName}</div>
                {/* 消息列表 */}
                <div className="chat-msg">
                    <div className="chat-msg-wrapper" ref="chatMsg">
                        {
                            msgList && msgList.length > 0 &&
                            msgList.map((item, index) => {
                                return (
                                    <div className={`chat-msg-item ${item.selfSendMsg ? 'me' : ''}`} key={index}>
                                        <div className="chat-msg-time">{moment(item.createTime * 1000).format('YYYY-MM-DD HH:mm:ss')}</div>
                                        <div className="chat-msg-wrap">
                                            <div className="chat-msg-content">
                                                {
                                                    item.selfSendMsg ?
                                                        <div className="avatar"
                                                            style={{
                                                                backgroundImage: `url(${(modelData && modelData.toUserImage && modelData.toUserImage !== null &&
                                                                    modelData.toUserImage.indexOf("s1.im-dangdang.com") !== -1) ?
                                                                    JSON.parse(modelData.toUserImage).picture : ""})`
                                                            }}></div> :
                                                        <div className="avatar"
                                                            style={{
                                                                backgroundImage: `url(${(modelData && modelData.fromUserImage && modelData.fromUserImage !== null &&
                                                                    modelData.fromUserImage.indexOf("s1.im-dangdang.com") !== -1) ?
                                                                    JSON.parse(modelData.fromUserImage).picture : ""})`
                                                            }}></div>
                                                }

                                                <div className={`bubble  text ${item.selfSendMsg ? 'right' : 'left'}`}>
                                                    <div className="bubble-cont">
                                                        <div className="plain">
                                                            <pre className="msg" dangerouslySetInnerHTML={{ __html: EMOJI.Word2Emoji(item.msg) }}></pre>
                                                            {/* <i v-show="message.msgStatus == 1" className="msg-loading"></i> 
                                            <i v-show="message.msgStatus == 3" className="msg-fail iconfont icon-liaotianneirongfasongshibaiicon"></i> */}
                                                        </div>
                                                    </div>
                                                </div >
                                            </div>
                                        </div>
                                    </div >
                                )
                            })
                        }
                    </div >
                    {/* 使页面保持在底部 */}
                    <div style={{ float: "left", clear: "both" }}
                        ref={(el) => { this.messagesEnd = el; }}>
                    </div>
                </div >

                <div className="send-msg">
                    {/* 功能栏 */}
                    <div className="expression">
                        <Icon type="smile" theme="twoTone" style={{ fontSize: '20px', color: '#08c' }} onClick={this.showExpression} />
                        <Divider type="vertical" />
                    </div>
                    { /*表情开始*/}
                    <div
                        id="chatEmojiPanel"
                        className={`chat-emoji-panel ${popExpress ? 'slide-top' : 'chat-emoji-panel-hide'}`}>
                        <div className="expression">
                            <div className="expression-wrapper">
                                <ul className="expression-tab">
                                    <li className="tab-item" onClick={() => this.active(1)} ><a className={`${tabindex === 1 ? 'active' : ''}`} >铛铛表情</a></li>
                                    <li className="tab-item" onClick={() => this.active(2)} ><a className={`${tabindex === 2 ? 'active' : ''}`} >黄豆表情</a></li>
                                </ul>
                                <div className="expression-inner">
                                    <div className={`express ${tabindex === 1 ? 'active' : ''}`}>
                                        <div id="selectEmoji" className="emoji-faces emoji-dangdang" >
                                            {
                                                emojiDang.map((item, index) => {
                                                    return <a key={index} title={item} type="dangdang" className={'emoji' + index} onClick={() => this.selectEmoji(item, 'dangdang', 'emoji' + index)}>{item}</a>
                                                })
                                            }
                                        </div>
                                    </div>
                                    <div className={`express ${tabindex === 2 ? 'active' : ''}`}>
                                        <div className="emoji-faces emoji-huangdou">
                                            {
                                                emojiHuangDou.map((item, index) => {
                                                    return <a key={index} title={item} type="emoji" className={'emoji' + index} onClick={() => this.selectEmoji(item, 'emoji', 'emoji' + index)}>{item}</a>
                                                })
                                            }
                                        </div>
                                    </div>
                                </div >
                            </div >
                        </div >
                    </div >
                    {/* 输入框 */}
                    < div className="send-content" >
                        <div id="editArea" ref="editArea" onFocus={this.onEditAreaFocus} onKeyDown={this.textAreaKeydown} className="edit-area" contentEditable="true"></div>
                    </div >
                    <Button type="primary" className="send-btn" onClick={this.send}>发送(Enter)</Button>
                </div >
            </Modal >
        )
    }
}

export default DialogBox